module.exports = __webpack_public_path__ + "static/img/A61801_4.ee57aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61801_4.png
// module id = jf7/
// module chunks = 1